import {createSlice, PayloadAction} from '@reduxjs/toolkit'
import {RootState} from '../../app/rootReducer'
import {ExternalLinkPopup} from '../../types/ExternalLinkPopup'

export const layersHandleSlice = createSlice({
    name: 'layersHandleSlice',
    initialState: {
        legalNotesText: '',
        externalLinkPopUp: [] as ExternalLinkPopup[],
    },
    reducers: {
        setLegalNotesText(
            state: RootState,
            action: PayloadAction<string>
        ): void {
            state.legalNotesText = action.payload
        },
        setExternalLinkPopUp(
            state: RootState,
            action: PayloadAction<ExternalLinkPopup>
        ): void {
            state.externalLinkPopUp = action.payload
        },
    },
})

export const {setLegalNotesText, setExternalLinkPopUp} =
    layersHandleSlice.actions
export default layersHandleSlice.reducer
